import { axiosClient } from "@/shared/api/axios";

export const apiClient = {
  get: axiosClient.get,
  post: axiosClient.post,
  put: axiosClient.put,
  patch: axiosClient.patch,
  delete: axiosClient.delete,
};

export default apiClient;
